import React, { memo } from 'react';

import { Route, Switch } from 'react-router-dom';

import PoweredBy from 'Components-redesign/PoweredBy';
import ActivateUser from 'Scenes-redesign/ActivateUser';
import Login from 'Scenes-redesign/Login';
import PasswordReset from 'Scenes-redesign/PasswordReset';
import Register from 'Scenes-redesign/Register';

import { FooterWrapper } from './styles';

const NonPrivateRoutes = ({ onRedirectEnabled }) => {
  const LoginWrapper: React.FunctionComponent = memo(() => (
    <Login onRedirectEnabled={onRedirectEnabled} />
  ));
  const RegisterWrapper: React.FunctionComponent = memo(() => <Register />);

  return (
    <>
      <Switch>
        <Route exact path="/reset-password" component={PasswordReset} key={'passwordReset'} />
        <Route exact path="/register" component={RegisterWrapper} key={'register'} />
        <Route exact path="/activate" component={ActivateUser} key={'activateUser'} />
        <Route component={LoginWrapper} key={'login'} />
      </Switch>
      <FooterWrapper>
        <PoweredBy dark={true} />
      </FooterWrapper>
    </>
  );
};

export default NonPrivateRoutes;
